<ng-content select="[formSide]"></ng-content>
<ng-content select="[widgetSide]"></ng-content>
